/* eslint-disable no-nested-ternary */
import { useNavigate } from "react-router-dom";
import {
  BlueBirdTheme,
  Breadcrumb,
  Divider,
  Loading,
  Typography,
} from "@kitbird/core";
import { PageCard, PageWrapper } from "../../../../../components/Content/Content.style";
import { HeaderText } from "../../../../../components/FloatHeader/FloatHeader.style";
import { useUserPosition } from "../../Provider";
import {
  HistoryDetailLabel,
  HistoryDetailRow,
  HistoryDetailValue,
  HistoryGroup,
  HistoryItem,
  HistoryWrapper,
  ModalBodyWrapper as BodyWrapper,
  ScrollableFormArea as ScrollableArea,
} from "./MutationUser.styled";
import UserPositionInfo from "./UserPositionInfo";
import logo from "../../../../../assets/icons/logogram_bb.png";
import BaseLoading from "../../../../../components/Loading/BaseLoading";
import EmptyState from "../../../BusinessTrx/components/EmptyState";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";

const MutationHistoryPage = () => {
  const navigate = useNavigate();
  const {
    user,
    isLoadingUser,
    errorUser,
    sourceUserPositions,
    userMutationHistory: histories,
    hasNextPageUserMutationHistory: hasNextPage,
    fetchNextPageUserMutationHistory: fetchNextPage,
    isFetchingUserMutationHistory: isFetching,
    isFetchingNextPageUserMutationHistory: isFetchingNextPage,
  } = useUserPosition();
  const observerRef = useInfiniteScroll({ hasNextPage, fetchNextPage });

  return (
    <PageWrapper>
      <HeaderText>
        <Typography level={3} color={BlueBirdTheme.colors.gray.title} fontWeight="medium">
          Riwayat mutasi
        </Typography>
      </HeaderText>
      <Breadcrumb
        items={[
          { title: "Master user", path: "LIST" },
          { title: "Riwayat mutasi" },
        ]}
        onClick={(item) => {
          if (item.path && item.path === "LIST") {
            navigate("/master-data/user-position");
          }
        }}
      />
      <PageCard style={{ height: "80vh" }}>
        <BodyWrapper>
          <div style={{
            display: "flex",
            gap: 9,
            fontWeight: 500,
            padding: "1rem 1rem 0 1rem",
            alignItems: "center",
          }}>
            <img src={logo} width={32} height={26} />
            <Typography level={4} fontWeight="medium" color={BlueBirdTheme.colors.gray.subtitle}>Riwayat Mutasi</Typography>
          </div>
          <div style={{ padding: "1rem 1rem 0 1rem" }}>
            <UserPositionInfo
              user={user}
              isError={errorUser}
              isLoading={isLoadingUser}
              variant="HISTORY"
              badge={{
                show: true,
                backgroundColor: user?.is_active
                  ? BlueBirdTheme.colors.success[500]
                  : BlueBirdTheme.colors.danger[400],
                color: BlueBirdTheme.colors.white,
                label: user?.is_active ? "Aktif" : "Tidak aktif",
                position: "top-right",
              }}
              userPosition={sourceUserPositions}
            />
          </div>
          <ScrollableArea>
            <HistoryWrapper>
              {isFetching && !isFetchingNextPage ? (
                <BaseLoading />
              ) : histories.length
                ? histories.map((history, index) => (
                  <div key={index}>
                    <HistoryItem>
                      <HistoryGroup>
                        <HistoryDetailRow>
                          <HistoryDetailLabel>
                            <Typography level={6} color={BlueBirdTheme.colors.gray.bodyText}>
                              Tanggal mutasi
                            </Typography>
                          </HistoryDetailLabel>
                          <HistoryDetailValue>
                            <Typography level={6} color={BlueBirdTheme.colors.gray.subtitle}>
                              <span>:</span>
                              <strong>{history.date}</strong>
                            </Typography>
                          </HistoryDetailValue>
                        </HistoryDetailRow>
                        <HistoryDetailRow>
                          <HistoryDetailLabel>
                            <Typography level={6} color={BlueBirdTheme.colors.gray.bodyText}>
                              Pool
                            </Typography>
                          </HistoryDetailLabel>
                          <HistoryDetailValue>
                            <Typography level={6} color={BlueBirdTheme.colors.gray.subtitle}>
                              <span>:</span>
                              <strong>{history.pool}</strong>
                            </Typography>
                          </HistoryDetailValue>
                        </HistoryDetailRow>
                      </HistoryGroup>
                      <HistoryGroup withBackground>
                        {history.details.map((detail) => (
                          <HistoryDetailRow key={detail.label}>
                            <HistoryDetailLabel>
                              <Typography level={6} color={BlueBirdTheme.colors.gray.bodyText}>
                                {detail.label}
                              </Typography>
                            </HistoryDetailLabel>
                            <HistoryDetailValue>
                              <Typography level={6} color={BlueBirdTheme.colors.gray.subtitle}>
                                <span>:</span>
                                <strong>{detail.value}</strong>
                              </Typography>
                            </HistoryDetailValue>
                          </HistoryDetailRow>
                        ))}
                      </HistoryGroup>
                    </HistoryItem>
                    {index < histories.length - 1 && (
                      <Divider color={"white"} style={{ margin: "0 -1rem" }} />
                    )}
                  </div>
                )) : <EmptyState />
              }
              <div ref={observerRef} />
              {isFetchingNextPage && (
                <div style={{ display: "flex", justifyContent: "center", padding: "1rem" }}>
                  <Loading variant="circular" />
                </div>
              )}
            </HistoryWrapper>
          </ScrollableArea>
        </BodyWrapper>
      </PageCard>
    </PageWrapper>
  );
};

export default MutationHistoryPage;
